module.exports = __webpack_public_path__ + "static/media/2S.b821dcd9.svg";